import { cmsInstanceQueryParam } from './cms-instance';

export const getPreviewUrl = (alias: string) => `https://${alias}.landings.feverup.dev`;

export const generatePreviewUrlAlias = (id: string, bucket: string) => {
  const processedBucket = bucket.toLowerCase().replaceAll('.', '-');
  return `${id}-${processedBucket}`;
};

export interface LivePreviewUrlParams {
  baseUrl: string;
  path: string;
  tenantName: string;
  bucket: string;
  locale: string;
  abParam?: string;
  cmsInstance?: string;
}

export const formatLivePreviewUrl = ({
  baseUrl,
  path,
  tenantName,
  bucket,
  locale,
  abParam = '',
  cmsInstance,
}: LivePreviewUrlParams): string =>
  `${baseUrl}${path}?landing=${tenantName}&bucket=${bucket}&locale=${locale}${abParam}${cmsInstanceQueryParam(cmsInstance)}`;
